import { axiosClient } from 'lib/axios'
import { DateTime } from 'luxon'
import { WorkdayEmployeeUpdates, WorkdayProfile } from './types'

export const getWorkdayProfile = async (employeeId: number, date: DateTime) => {
  const response = await axiosClient.get<WorkdayProfile>(
    `/employees/${employeeId}/workday_profile`,
    { params: { date: date.toISODate() } },
  )
  return response.data
}

export const getWorkdayEmployeeUpdates = async (employeeId: number) => {
  const response = await axiosClient.get<WorkdayEmployeeUpdates>(
    `/employees/${employeeId}/workday_employee_updates`,
  )
  return response.data
}
